var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackageLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 15.1c-2.7 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5c-.1-2.8-2.4-5-5-5zm0 8.1c-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3.1 3.1-3.1 1.7 0 3.1 1.4 3.1 3.1 0 1.7-1.4 3.1-3.1 3.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 11.5c-.5 0-1 .1-1.5.1v-5C26 5.2 24.7 4 23.3 4H6.7C5.2 4 4 5.2 4 6.7v16.7C4 24.8 5.2 26 6.7 26h13.8c2.2 5 6.1 9.5 6.3 9.7.3.4 1 .4 1.4-.1.3-.4 7.8-9.6 7.8-15.7-.1-4.6-3.9-8.4-8.5-8.4zm-15-5.7h4.8V10l-1 .5-1.7-1.2c-.2-.1-.4-.2-.7-.1l-1.4.3V5.8zm7.2 18.4H6.6c-.5 0-.9-.4-.9-.9v-2.9h1.8c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H5.7v-1.8h3.5c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H5.7V6.7c0-.5.4-.9.9-.9h4.1v4.7c-.1.6.5 1 1.1.9l2-.5 1.8 1.4c.3.2.7.2 1 .1l2-1c.3-.1.5-.5.5-.8V5.8h4.1c.5 0 .9.4.9.9v5.4c-3.1 1.3-5.2 4.3-5.2 7.8 0 1.4.3 2.9.8 4.3zm7.7 9.5c-1.8-2.2-6.7-8.7-6.7-13.7a6.7 6.7 0 0113.4 0c0 4.4-4.9 11.3-6.7 13.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageLocation);
export default __webpack_public_path__ + "static/media/package-location.5cd3f8f3.svg";
export { ForwardRef as ReactComponent };